import React, { useState } from "react";
import { format, addDays } from "date-fns";
import CommonFilterStructure from "../../common-components/CommonFilterStructure";

const StaffLeaveDetTbFilters = ({
  userInfoData,
  filters,
  setFilters,
  searchFilterApplied,
  onClickReset,
  prevGymId,
  staffLeaveStats,
  staffLeavesStats,
  staffLeavesYearStats,
  isNotAdmin,
  isLMAdminDate,
  approvalManagerFor,
  isLMStaffDate,
}) => {
  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setFilters({
      ...filters,
      selectedStartDate: formattedStartDate,
      selectedEndDate: formattedEndDate,
    });
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setFilters({
      ...filters,
      selectedStartDate: "",
      selectedEndDate: "",
    });
  };

  return (
    <CommonFilterStructure
      from={"leave-management-admin"}
      decryptedText={userInfoData}
      setFilters={setFilters}
      filters={filters}
      searchFilterApplied={searchFilterApplied}
      openDateRanger={openDateRanger}
      onClickReset={onClickReset}
      handleDateRangeChange={handleDateRangeChange}
      setOpenDateRanger={setOpenDateRanger}
      rangeState={rangeState}
      clearDateRanger={clearDateRanger}
      prevGymId={prevGymId}
      staffLeaveStats={staffLeaveStats}
      staffLeavesStats={staffLeavesStats}
      staffLeavesYearStats={staffLeavesYearStats}
      isNotAdmin={isNotAdmin}
      isLMAdminDate={isLMAdminDate}
      approvalManagerFor={approvalManagerFor}
      isLMStaffDate={isLMStaffDate}
    />
  );
};

export default StaffLeaveDetTbFilters;
